import { createOnAndOffNamespaceListeners, } from "../utils.js";
const listeners = createOnAndOffNamespaceListeners("app");
/**
 * Subcribes to an event on the app object.
 *
 * @param eventName - The event name to subscribe to.
 * @param callback - The callback function to execute when the event occurs.
 * @param options - ref: Reference for the Tray.
 * @returns unsubscribe callback.
 * @public
 */
export const on = listeners.on;
/**
 * Unsubscribes all listeners from the event name.
 *
 * @param options - ref: Reference for the Tray; eventName: The event name to unsubscribe from;
 * @returns Reference for the tray.
 * @public
 */
export const removeAllListeners = listeners.removeAllListeners;
